import { axiosIns } from "config/api.config";

export const BillingService = {
  getInvoiceList: async (payload): Promise<any> => await axiosIns.post(`/invoice/filter`, payload),
  getInvoiceDetails: async (id): Promise<any> => await axiosIns.get(`/invoice/detail/${id}`),
  // A refusal (core auth, a bad id) comes back as JSON, so Accept must admit it: a PDF-only Accept
  // turns every refusal into an empty 500. The caller checks the blob's type before saving it.
  downloadInvoicePdf: async (id): Promise<any> =>
    await axiosIns.get(`/invoice/pdf/${id}`, {
      responseType: "blob",
      headers: { Accept: "application/pdf, application/json" },
    }),
  getOfflinePayMethods: async (): Promise<any> => await axiosIns.get(`/master/public/get-offline-pay-methods`),
  submitOffilnePayment: async (payload): Promise<any> => await axiosIns.put(`/invoice/offline-payment`, payload),
  getOnlinePayMethods: async (): Promise<any> => await axiosIns.get(`/master/public/get-online-pay-methods`),
  payBySslcommerz: async (invoiceId, companyId): Promise<any> => await axiosIns.get(`/pay-now/public/sslcommerz/${invoiceId}/${companyId}`),
  // Creates a Paddle transaction and returns { transactionId, clientToken, environment, ... } for
  // the overlay. Unlike SSLCommerz this answers JSON — Paddle never leaves the page.
  initPaddlePayment: async (invoiceId, companyId): Promise<any> => await axiosIns.post(`/pay-now/public/paddle/${invoiceId}/${companyId}`),
  // Client token only, for reopening a checkout Paddle itself originated (?_ptxn=... links).
  getPaddleCheckoutContext: async (): Promise<any> => await axiosIns.get(`/pay-now/public/paddle/checkout-context`),
};
